import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContentRequest = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_257_892)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_257_892",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_257_892)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3.5 15.368V13.868H10.5V15.368H3.5ZM3.5 11.368V9.868H14.5V11.368H3.5ZM3.5 7.368V5.868H14.5V7.368H3.5ZM16.5 19.368V15.368H12.5V13.868H16.5V9.868H18V13.868H22V15.368H18V19.368H16.5Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_257_892",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgContentRequest;
